module.exports = __webpack_public_path__ + "static/media/nimiia-cetii-logo.c12216ae.png";